export default __webpack_public_path__ + "static/media/020204202190105.76efca5e.png";